import { useEffect, useState } from "react";
import { Route, Routes, useSearchParams } from "react-router";
import styled from "styled-components";
import media from "styled-media-query";
import { useDispatch, useSelector } from "react-redux";
import { actionsCreators, State } from "../redux";
import { bindActionCreators } from "redux";

import Detail from "../views/pack/Detail";

import { Feedback } from "@adoptaunabuelo/react-components";
import { Product, ProductScheme } from "client-v2";
import Loading from "../components/modal/Loading";

const FeedbackStyled = styled(Feedback)`
	right: 24px !important;
	left: unset !important;
	${media.lessThan("small")`
        top: 64px;
        left: 24px !important;
        bottom: unset !important;
	`}
`;

const PackLayout = (props: PackLayoutProps) => {
	const dispatch = useDispatch();
	const { setShowError } = bindActionCreators(actionsCreators, dispatch);
	const error = useSelector((state: State) => state.modals.error);
	const [searchParams, setSearchParams] = useSearchParams();
	const [product, setProduct] = useState<ProductScheme | undefined>(
		undefined
	);

	useEffect(() => {
		const id = searchParams.get("id");
		if (id) {
			Product.getById(id)
				.then((result) => {
					if (result.data.type === "shop") {
						setProduct(result.data);
					} else {
						setShowError({
							show: true,
							message: "El producto no es válido",
						});
					}
				})
				.catch((error) => {
					setShowError({
						show: true,
						message: "El parámetro id no es válido",
					});
				});
		} else {
			setShowError({
				show: true,
				message: "El parámetro id no es válido",
			});
		}
	}, []);

	return (
		<>
			<FeedbackStyled
				isVisible={error.show}
				type="error"
				text={error.message}
				onClose={() => setShowError({ show: false })}
			/>
			<Routes>
				<Route
					path="/"
					element={
						!product ? (
							<Loading isVisible={true} />
						) : (
							<Detail product={product} />
						)
					}
				/>
			</Routes>
		</>
	);
};

export default PackLayout;
export interface PackLayoutProps {}
